import { OrganizationRoleType } from "../../autogen/bff-api";

const adminOrOwnerRoles: OrganizationRoleType[] = [OrganizationRoleType.Admin, OrganizationRoleType.Owner];

const creatorRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Admin,
  OrganizationRoleType.Owner,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ProjectCreator,
];

export const isOwnerOrAdmin = (roles: OrganizationRoleType[]) => adminOrOwnerRoles.some((role) => roles.includes(role));

export const isCreator = (roles: OrganizationRoleType[]) => creatorRoles.some((role) => roles.includes(role));
